class ComponentsBuildDirector {

    /**
     * @constructor
     * @desc Initialise the director instance
     * @param {Object} builders - A mapping of builder types;
     */
    constructor(builders) {
        this.builders = builders;
    }

    /**
     * @desc build the laid out components on a schema object and array of builders
     * @param {Array} componentNameList - array of component names, could be layout, builder or generic component
     * @param {Object} extraProps - extraProps you want to pass down to all sub components
     * @throws {Error} Will throw an error if an invalid componentType is defined in schema
     * @returns {Array} Array of JSX components
     */
    constructComponents = (componentNameList, extraProps = {}) => {
        if (typeof componentNameList === 'undefined' || componentNameList === null) {
            throw Error(`Components are not defined in: ${componentNameList}`);
        }

        const components = [];

        for (const componentName of componentNameList) {
            // ComponentName looks like 'layout_xxx', 'form_xxx' or 'component_xxx'
            // split the string so we have the componentType and componentKey
            const builderType = componentName.split('_')[0];
            // This is to cater for if you have a componentName as 'component_my_special_component'
            // But generally we should use camel case for the componentKey, e.g 'component_mySpecialComponent'
            const componentKey = componentName.split('_').slice(1).join('_');

            const component = componentKey
                && builderType
                && this.builders[builderType]
                && this.builders[builderType](componentKey, extraProps);

            // only push valid component
            if (component) {
                components.push(component);
            } else {
                // eslint-disable-next-line no-console
                console.warn(`ComponentsBuildDirector was unable to construct a ${builderType} for: ${componentName}`);
            }
        }

        return components;
    };

}

export { ComponentsBuildDirector };
